import { render } from "./PartGroupModal.vue?vue&type=template&id=2a8ee4fa"
import script from "./PartGroupModal.vue?vue&type=script&lang=js"
export * from "./PartGroupModal.vue?vue&type=script&lang=js"
script.render = render

export default script